import { AdState } from 'common/advertising/ad-state'
import { GptAdSlotDefinition } from 'common/advertising/gpt-ad-slot-definintion'
import {
    getAdSlotId,
    AdDefinition,
    AdTargeting,
    adSlotsAsArray,
    getAds,
} from 'common/advertising/add-ads'

export function getAdState(
    routeAdTargeting: AdTargeting,
    pageAds: AdDefinition[],
    pathname: string
) {
    const { slotMap, breakpoints } = getAds(routeAdTargeting, pageAds)
    const unitsArray: GptAdSlotDefinition[] = slotMap ? adSlotsAsArray(slotMap) : []
    const pageKey = pathname
    const safePageKey = pageKey === '' ? 'home' : pageKey

    const adState: AdState = {
        pageKey: safePageKey,
        definition: pageAds,
        targeting: routeAdTargeting,
        unitLookup: (adId, windowWidth) => {
            let breakpoint = 0
            for (let index = breakpoints.length - 1; index >= 0; index--) {
                breakpoint = breakpoints[index]
                if (breakpoints[index] <= windowWidth) {
                    break
                }
            }

            const slotId = getAdSlotId(breakpoint, adId)
            const foundSlot = slotMap[slotId]
            return foundSlot
        },
        breakpoints,
    }

    return { safePageKey, unitsArray, adState }
}
